module.exports = __webpack_public_path__ + "media/gamend.4110b8d3.mp3";